/**
 * kp-reveal — adds `kp-in` to every `[data-kp-reveal]` block the first time
 * it is 12% into the viewport. Once; the class never comes off.
 *
 * `data-kp-reveal-group` on a list marks each direct child as a block and
 * numbers it in --kp-ri (index % 6, so a long grid's last row never waits
 * on the first). A child that already carries data-kp-reveal — a product
 * card, a review card — keeps its own attribute and only takes the index.
 *
 * Content that arrives later — Dawn re-rendering a grid after a facet
 * change, a section loaded in the editor — is picked up by a MutationObserver
 * so nothing added after load can be stuck at opacity 0.
 *
 * In the theme editor and under reduced motion every block is marked `kp-in`
 * at once: the CSS already shows them, the class only keeps the glint and
 * the drawn lines consistent with what the visitor sees.
 */
(function () {
  if (window.kpRevealArmed) return;
  window.kpRevealArmed = true;

  var root = document.documentElement;
  var STAGGER_WRAP = 6;

  function instant() {
    return root.classList.contains('shopify-design-mode')
      || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // The root is the viewport minus its bottom 12%, extended a long way UP:
  // a block is "in" once its top has crossed that 12% line, and a block the
  // page jumped past (a hash link, a restored scroll position) is inside the
  // extended root and reveals at once. Without the extension a jump that
  // carries a block from below the viewport to above it never changes its
  // intersection state, and it stays at opacity 0 for good.
  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('kp-in');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '100000px 0px -12% 0px', threshold: 0 })
    : null;

  function arm(scope) {
    scope.querySelectorAll('[data-kp-reveal-group]').forEach(function (group) {
      var i = 0;
      Array.prototype.forEach.call(group.children, function (child) {
        if (!child.hasAttribute('data-kp-reveal')) child.setAttribute('data-kp-reveal', '');
        child.style.setProperty('--kp-ri', String(i % STAGGER_WRAP));
        i += 1;
      });
    });

    var blocks = scope.querySelectorAll('[data-kp-reveal]:not(.kp-in)');
    if (!blocks.length) return;

    if (!observer || instant()) {
      blocks.forEach(function (el) { el.classList.add('kp-in'); });
      return;
    }
    blocks.forEach(function (el) { observer.observe(el); });
  }

  function armSoon(scope) {
    requestAnimationFrame(function () { arm(scope || document); });
  }

  arm(document);

  new MutationObserver(function (records) {
    for (var r = 0; r < records.length; r += 1) {
      if (records[r].addedNodes.length) { armSoon(document); return; }
    }
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', function (e) { armSoon(e.target); });
})();
